module.exports = __webpack_public_path__ + "front/img/4_a.cdcaa852.png";